export { default } from './Disclaimer';
